// Project
import * as applicationConfig from "../../../config/application";

const delimiterRegex = new RegExp(applicationConfig.draftView.addressDelimiters, "u");

/**
 * Check to see if a string contains a delimiter.
 *
 * @param {String} inputString - String to be checked.
 * @return {Boolean} Delimiter exists in string.
 */
export default function containsDelimiter(inputString) {
  return inputString.match(delimiterRegex) !== null;
}
